import { CheckmarkEmpty } from '@/components/Icons';

interface Step {
    text?: string;
    icon?: React.ReactNode;
}

interface StepperProps {
    steps: Step[];
    defaultIcon?: React.ReactNode;
}

export const Stepper: React.FC<StepperProps> = ({
    steps,
    defaultIcon = <CheckmarkEmpty />,
}) => {
    const totalSteps = steps.length;

    return (
        <div
            className="relative grid items-start"
            style={{ gridTemplateColumns: `repeat(${totalSteps}, 1fr)` }}
        >
            {steps.map((step, index) => {
                const isFirst = index === 0;
                const isLast = index === totalSteps - 1;
                const icon = step.icon ?? defaultIcon;

                return (
                    <div
                        key={index}
                        className="relative flex flex-col items-center"
                    >
                        {isFirst && (
                            <div className="absolute top-3 left-1/2 h-0.5 w-1/2 bg-gray-700"></div>
                        )}

                        {!isFirst && !isLast && (
                            <div className="absolute top-3 left-0 h-0.5 w-full bg-gray-700"></div>
                        )}

                        {isLast && (
                            <div className="absolute top-3 right-1/2 h-0.5 w-1/2 bg-gray-700"></div>
                        )}

                        <div className="z-20 w-fit bg-white px-1">{icon}</div>

                        {step.text && (
                            <div className="mt-2 text-center text-sm break-words">
                                {step.text}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};
